module.exports = __webpack_public_path__ + "static/feedback-52a0e485aedaf0d7d0aae2892c67407b.jpg";